import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-[1200px] mx-auto px-6 lg:px-12 py-20">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="overline text-[#C5A059]">Our Story</div>
          <h1 className="serif text-5xl lg:text-7xl mt-4 leading-[0.95]">A house built<br/> on intention.</h1>
          <p className="mt-8 text-[#5A5A5A] leading-relaxed">
            Atelier Noir was founded in 2021 by two women who could not find what they were looking for. A wardrobe that was modest without being modest-looking. Hijabs that felt like air. Bags built like architecture.
          </p>
          <p className="mt-6 text-[#5A5A5A] leading-relaxed">
            So we built it ourselves — a small atelier in Paris, with a workshop of leather artisans, weavers, and a sketchbook that never closes. Every piece is cut, sewn, and finished in-house. Every bespoke bag is sketched twice before a single stitch is made.
          </p>
        </div>
        <div className="img-zoom aspect-[4/5]">
          <img src="https://images.pexels.com/photos/13562820/pexels-photo-13562820.jpeg" alt="Atelier Noir founders" className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-12 mt-32">
        {[
          { t: "Modest by design", d: "We design for the way you actually move. Generous cuts, considered necklines, fabrics that fall instead of cling." },
          { t: "Handmade, not assembled", d: "Every piece passes through human hands. Our leather artisans average 19 years of practice." },
          { t: "Built to outlast trend", d: "Restraint is our discipline. We release small editions, twice a year, made to outlive seasons." },
        ].map((v) => (
          <div key={v.t}>
            <div className="serif text-3xl">{v.t}</div>
            <p className="text-[#5A5A5A] mt-3 leading-relaxed">{v.d}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-32">
        <h2 className="serif text-4xl lg:text-5xl">Visit the atelier.</h2>
        <p className="text-[#5A5A5A] mt-4">By appointment, 12 rue de Sévigné, Paris.</p>
        <Link to="/contact" className="btn-outline mt-8 inline-flex" data-testid="about-contact-link">Book a visit</Link>
      </div>
    </div>
  );
}
